import { render } from "./preloader.vue?vue&type=template&id=4661cbb9"
import script from "./preloader.vue?vue&type=script&lang=js"
export * from "./preloader.vue?vue&type=script&lang=js"

import "./preloader.vue?vue&type=style&index=0&id=4661cbb9&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__